import {TouchableOpacity, View} from 'react-native';
import Text from '@/components/basic/text';
import Button from '@/components/basic/button';
import React from 'react';
import theme from '@/style';
import Dustbin from '@/components/svgs/basic/dustbin';
import {useTranslation} from 'react-i18next';

export interface BetsActionsProps {
  onAdd?: (view?: View | HTMLElement | null) => void;
  counts?: number;
  onDel?: () => void;
}

const BetsActions = ({counts = 0, onAdd, onDel}: BetsActionsProps) => {
  const {t} = useTranslation();
  const viewRef = React.useRef<View>(null);
  const webRef = React.useRef<HTMLDivElement | null>(null);

  if (typeof document !== 'undefined') {
    return (
      <div style={stylesWeb.wrap}>
        <div style={stylesWeb.countWrap}>
          <span style={stylesWeb.label}>Bet Slip Counts:</span>
          <span style={stylesWeb.count}>{counts}</span>
        </div>
        <div style={stylesWeb.actionWrap}>
          <button
            onClick={() => onDel?.()}
            disabled={counts === 0}
            style={{
              ...stylesWeb.delBtn,
              ...(counts === 0 ? stylesWeb.disabled : null),
            }}
            type="button">
            <Dustbin />
          </button>
          <div ref={webRef}>
            <button
              disabled={counts === 0}
              onClick={() => onAdd?.(webRef.current)}
              style={{
                ...stylesWeb.addBtn,
                ...(counts === 0 ? stylesWeb.disabledAdd : null),
              }}
              type="button">
              {t('mix-lotto.label.addToBetSlip')}
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <View
      style={[
        theme.flex.row,
        theme.flex.between,
        theme.flex.centerByCol,
        theme.padding.l,
        theme.margin.btml,
        // eslint-disable-next-line react-native/no-inline-styles
        {backgroundColor: '#F7F9FF'},
      ]}>
      <View
        style={[
          theme.flex.row,
          theme.flex.centerByCol,
          {gap: theme.paddingSize.s},
        ]}>
        <Text fontWeight="500">Bet Slip Counts:</Text>
        <Text fontFamily="fontInterBold" color={theme.basicColor.dark}>
          {counts}
        </Text>
      </View>
      <View style={[theme.flex.row, theme.flex.centerByCol]}>
        <TouchableOpacity
          onPress={() => onDel?.()}
          disabled={counts === 0}
          activeOpacity={0.8}
          style={[
            {marginRight: theme.paddingSize.m * 2},
            // eslint-disable-next-line react-native/no-inline-styles
            counts === 0 && {opacity: 0.3},
          ]}>
          <Dustbin />
        </TouchableOpacity>
        <View collapsable={false} ref={viewRef}>
          <Button
            disabled={counts === 0}
            onPress={() => onAdd?.(viewRef.current)}
            // eslint-disable-next-line react-native/no-inline-styles
            disabledStyle={[{opacity: 0.3}, theme.background.primary]}
            type="primary"
            titleFontFamily="fontInterBold"
            title={t('mix-lotto.label.addToBetSlip')}
          />
        </View>
      </View>
    </View>
  );
};

export default BetsActions;

const stylesWeb: Record<string, React.CSSProperties> = {
  wrap: {
    marginBottom: '0.75rem',
    padding: '0.75rem',
    backgroundColor: '#F7F9FF',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  countWrap: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
  },
  label: {
    fontSize: '1rem',
    lineHeight: '1.5rem',
    fontWeight: 500,
    color: '#31373D',
  },
  count: {
    fontSize: '1rem',
    lineHeight: '1.5rem',
    fontWeight: 700,
    fontFamily: 'Inter-Bold',
    color: theme.basicColor.dark,
  },
  actionWrap: {
    display: 'flex',
    alignItems: 'center',
  },
  delBtn: {
    marginRight: '1rem',
    background: 'transparent',
    border: 'none',
    padding: 0,
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  addBtn: {
    minWidth: '9rem',
    height: '2.5rem',
    border: 'none',
    borderRadius: '9999px',
    padding: '0 1rem',
    backgroundColor: theme.basicColor.primary,
    color: '#FFFFFF',
    fontSize: '0.875rem',
    lineHeight: '1.25rem',
    fontWeight: 700,
    fontFamily: 'Inter-Bold',
    cursor: 'pointer',
  },
  disabled: {
    opacity: 0.3,
    cursor: 'default',
  },
  disabledAdd: {
    opacity: 0.3,
    cursor: 'default',
  },
};
